import * as React from 'react';
export const IMSvg = React.forwardRef(function IMSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      fill: '#E25950',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.98 7.5 6.2 5.05 4 7m3.98.5L6.42 11l2.58.5m-1.02-4 3.52.5V5.06',
      stroke: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm10.22 10.35-.37.02h-.03l-.02-.03-.14-.31-.03-.02a.06.06 0 0 0-.06 0l-.01.03-.1.33v.02l-.04.01-.37.03-.03.01-.02.02v.03l.02.03.32.17c.02.02.03.04.02.06l-.08.33v.03l.02.02a.06.06 0 0 0 .06 0l.29-.21.03-.01h.03l.31.17a.06.06 0 0 0 .06 0l.02-.03v-.03l-.14-.31v-.03l.01-.03.29-.22.01-.02v-.03c0-.01 0-.02-.02-.03h-.03Zm-4.5-3-.37.02h-.03l-.02-.03-.14-.31-.03-.02a.06.06 0 0 0-.06 0l-.01.03-.1.33v.02l-.04.01-.37.03-.03.01-.02.02v.03l.02.03.32.17c.02.02.03.04.02.06l-.08.33v.03l.02.02a.06.06 0 0 0 .06 0l.29-.21.03-.01h.03l.31.17a.06.06 0 0 0 .06 0l.02-.03v-.03l-.14-.31v-.03l.01-.03.29-.22.01-.02v-.03c0-.01 0-.02-.02-.03h-.03Zm5-2.25-.37.02h-.03l-.02-.03-.14-.31-.03-.02a.06.06 0 0 0-.06 0l-.01.03-.1.33v.02l-.04.01-.37.03-.03.01-.02.02v.03l.02.03.32.17c.02.02.03.04.02.06l-.08.33v.03l.02.02a.06.06 0 0 0 .06 0l.29-.21.03-.01h.03l.31.17a.06.06 0 0 0 .06 0l.02-.03v-.03l-.14-.31v-.03l.01-.03.29-.22.01-.02v-.03c0-.01 0-.02-.02-.03h-.03Z',
      fill: '#FCD669',
    }),
  );
});
IMSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var IM = {
  category: 'flag',
  colorable: false,
  name: 'IM',
  svg: IMSvg,
};
